import React, { useEffect, useState } from 'react'

const SimplifiedPageWarning = () => {

  return (
    <div>
    </div>
  )
}

export default SimplifiedPageWarning
